module.exports = __webpack_public_path__ + "static/media/firebase.782c0be4.jpg";